import AirportsService from "@/core/services/airports.service";
import ApiService from "@/core/services/api.service";
import APIEndpointsService from "@/core/services/api-endpoints.service";
import AvailableAircraftService from "@/core/services/available-aircraft.service";
import ServiceRegistry from "@/core/services/service-registry";
import TermsAcceptService from "@/core/services/terms-accept.service";

const apiService = new ApiService();
const apiEndpointsService = new APIEndpointsService();

ServiceRegistry.register(ApiService, apiService);
ServiceRegistry.register(
	AirportsService,
	new AirportsService(apiService, apiEndpointsService),
);
ServiceRegistry.register(
	AvailableAircraftService,
	new AvailableAircraftService(apiService, apiEndpointsService),
);
ServiceRegistry.register(
	TermsAcceptService,
	new TermsAcceptService(apiService, apiEndpointsService),
);
